import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router';
import { useAuth } from './auth-provider';

export function useAuthenticate(): { isSynchingStore: boolean } {
  const { isAuthenticated, isLoading, signIn } = useAuth();
  const [isSynchingStore, setIsSynchingStore] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const errorParam = searchParams.get('error');

  useEffect(() => {
    // USER NOT AUTHENTICATED:
    // request user to login and store the URL he was trying to access
    if (isAuthenticated || isLoading || errorParam) {
      return;
    }

    window.sessionStorage.setItem(
      'pre-auth-url',
      `${location.pathname}${location.search}`
    );

    signIn();
  }, [errorParam, isAuthenticated, isLoading, location, signIn]);

  useEffect(() => {
    // USER IS AUTHENTICATED:
    // redirect user to the URL he was trying to access after login success (if any)
    if (!isAuthenticated) {
      return;
    }
    const preAuthUrl = window.sessionStorage.getItem('pre-auth-url');
    window.sessionStorage.removeItem('pre-auth-url');

    setIsSynchingStore(false);
    if (preAuthUrl) {
      navigate(preAuthUrl);
    }
  }, [isAuthenticated, navigate]);

  return { isSynchingStore };
}
